import React, { useState } from "react";

import { SolutionsFrame } from "components/solutions/SolutionsFrame";
import { BlockStandard } from "components/admin/BlockStandard";
import { TextField, Typography } from "@mui/material";
import { useGreenEnergyContext } from "contexts/GreenEnergyContext";
import { useSetError, useErrorInfo } from "contexts/ErrorContext";
import { CustomCodes } from "contexts/ErrorContextData";

const FRAME_DATA = {
  title: "Buscar melhores soluções",
  buttonText: "Continuar",
  nextScreen: "device-registry",
  skipTo: "device-registry",
  h2Subtitle: "Qual seu custo com energia?",
  explanationBody: "Esse dado será para calcular as melhores soluções",
  imgSrc: "/static/img/solutions/simulator.png",
};

export const EnergyCost = ({ history }) => {
  const [cost, setCost] = useState<string>("");
  const { setMonthlyCost } = useGreenEnergyContext();
  const setGlobalError = useSetError();
  const errorInfo = useErrorInfo();
  const hasFormError = errorInfo?.code === CustomCodes.INCOMPLETE_FORM;

  const handleButton = () => {
    if (cost) {
      setMonthlyCost(cost);
      history.push(FRAME_DATA.nextScreen);
    } else {
      setGlobalError(CustomCodes.INCOMPLETE_FORM);
    }
  };

  return (
    <SolutionsFrame {...FRAME_DATA} onButtonClick={handleButton}>
      <BlockStandard hideDivider>
        <Typography variant="h2"></Typography>
        <Typography></Typography>
        <TextField
          error={hasFormError}
          placeholder="R$ 500,00 / mês"
          variant="outlined"
          value={cost}
          onChange={({ target }) => setCost(target.value)}
        />
      </BlockStandard>
    </SolutionsFrame>
  );
};
